import { Container, Typography } from "@mui/material";
import { TitleWithBody } from "../../types/utils";
import useIsMobileView from "../../utils/hooks/useIsMobileView";
import CollapsibleText from "../Common/CollapsibleText";
import { downloadInstructionsFileDocx } from "../../utils/file-utils";

const InfoForPatient = () => {
  const IsMobileView = useIsMobileView();
  return (
    <Container
      disableGutters
      sx={{
        height: "100%",
        pr: IsMobileView ? "0%" : "1%",
      }}
    >
      <Container disableGutters sx={styles.contentContainer}>
        <Container disableGutters sx={styles.titleContainer}>
          <Typography variant="h5" align="center">
            Info tavakasutajale
          </Typography>
        </Container>
        {PatientInfo.map((data, index) => {
          return <CollapsibleText key={index} title={data.title} body={data.body} references={data.references} />;
        })}
      </Container>
    </Container>
  );
};

export default InfoForPatient;

const styles = {
  contentContainer: {
    height: "inherit",
    backgroundColor: "white",
    borderRadius: "20px",
    py: "5%",
    px: "5%",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    mb: "6%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
};

const PatientInfo: TitleWithBody[] = [
  {
    title: "Mis on düsartria?",
    body:
      "Inimene kasutab kõnelemiseks palju lihaseid: nendeks on näo, huulte, keele ja kõri lihased ning lisaks ka " +
      "hingamist tagavad lihased. Düsartria puhul on kõnelemisega seotud lihaste töö häiritud (nt ei suuda inimene " +
      "kontrollida keele liigutusi, rääkimine muutub aeglasemaks) ning kuulajal võib olla keeruline tema kõnest aru " +
      "saada (sõnade hääldus on moonutatud, hääl vaikne vms).",
    references: {},
  },
  {
    title: "Düsartria põhjused",
    body:
      "Düsartriat põhjustab ajukahjustus, mis võib tekkida sünnihetkel või elu jooksul mõne haiguse või trauma " +
      "tõttu. Düsartriat võivad põhjustada nt insult, peatrauma, kasvajad, Parkinsoni tõbi, motoneuroni haigused " +
      "(nt amüotroofiline lateraalskleroos), Sclerosis multiplex, lihasdüstroofia.",
    references: {},
  },
  {
    title: "Düsartria tunnused",
    body:
      "Düsartria avaldumine on individuaalne. Häiritud võib saada hääldus - kõne võib olla „pehmekeelne“ ehk " +
      "pomisev. Muutuda võib kõne tempo, olles kas liiga aeglane või kiire. Hääl võib muutuda kähedaks, kahisevaks, " +
      "hingeldavaks. Kõne võib muutuda „nohuseks“ või vastupidi nina kaudu kõlavaks",
    references: {},
  },
  {
    title: "Mida annab DÜKA test mulle tavakasutajana? ",
    body:
      "DÜKA testi alusel saate kontrollida, kuivõrd arusaadav on teie kõne kuulajale. Kui osalete logopeedilises" +
      " teraapias ja teete harjutusi oma kõne kvaliteedi parandamiseks, saate DÜKA testi alusel jälgida, kas ja" +
      " kui kiiresti teie kõne muutub arusaadavamaks. Pange aga tähele, et DÜKA test on mõeldud eeskätt mõõduka" +
      " ja raske düsartriaga inimestele. Kui teil on kerge düsartria, ei pruugi DÜKA test kõrvalekaldeid näidata" +
      " ning saadud skoor võib osutuda 100%-ks. ",
    references: {},
  },
  {
    title: "Kas tavakasutaja saab DÜKA testi läbiviimisega hakkama?",
    body:
      "Jah, DÜKA testi läbiviimine on väga lihtne. Kõik, mida teil vaja läheb, on üks hea partner, kes kuulab teie" +
      " kõnet, arvuti, väljaprintimise võimalus ja pastakas. Selle [juhendi][1] alusel saate " +
      "testimiseks ette valmistuda, [siin][2] saate proovitestiga tutvuda.",
    references: {
      1: () => (
        <a
          href=""
          onClick={(event) => {
            event.preventDefault();
            downloadInstructionsFileDocx();
          }}
          target="_blank"
          rel="noreferrer"
        >
          juhendi
        </a>
      ),
      2: () => (
        <a href="/proovitest" target="_blank" rel="noreferrer">
          siin
        </a>
      ),
    },
  },
];
